<template>
	<div>
		<template v-if="loadingClients">
			<div class="div__loading">
				<Loader />
			</div>
		</template>
		<template v-else>
			<div class="main__header">
				<div class="main__primary">
					<h3>Client</h3>
				</div>
				<div class="form__search-wrapper">
					<label class="form__label" for="search-user">
						<input
							id="search-user"
							class="form-control form__input form__search"
							type="search"
							v-model="query"
							@keyup.enter="search"
							placeholder="Type to search for a Client"
						/>
						<span class="form__search__icon">
							<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<title>Search Icon</title>
								<path
									d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 
									9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 
									0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
									fill="#828282"
								/>
							</svg>
						</span>
					</label>
					<small class="error-feedback">{{ queryError }}</small>
				</div>
			</div>
			<section class="main-grid__row contacts contacts--list">
				<div class="contacts--list__wrapper">
					<div class="contacts--list__item head">
						<div></div>
						<p>ID</p>
						<p>Key</p>
						<p>Secret</p>
					</div>
					<div class="contacts__body">
						<template v-if="clientsLoaded && clients.length > 0">
							<ClientItem v-for="client in clients" :key="client.id" :clientData="client" />
						</template>
						<template v-else-if="getsearchClients && getsearchClients.length === 0">
							<p class="mt-5 pl-5">No Client found</p>
						</template>
						<template v-else>
							<p class="alert alert-danger">
								An error occurred while loading Clients, please try again.
							</p>
						</template>
					</div>
				</div>
			</section>
			<Pagination :options="{ limit, offset, total, baseUrl }" v-if="total > limit" />
		</template>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loader from '../../components/Loader';
import Pagination from '../../components/Pagination';
import ClientItem from './ClientItem';

export default {
	name: 'Client',
	components: {
		Loader,
		Pagination,
		ClientItem
	},
	data() {
		return {
			clientsLoaded: false,
			loadingClients: true,
			offset: 0,
			limit: 10,
			baseUrl: 'clients',
			query: '',
			total: 0,
			queryError: ''
		};
	},
	created() {
		this.limit = this.$route.query.limit ? this.$route.query.limit : this.limit;
		this.offset =
			this.$route.query.offset || this.$route.query.offset === 0 ? this.$route.query.offset : this.offset;
		this.fetchAllClients([this.limit, this.offset]);
	},
	watch: {
		status(value) {
			if (value === 'success') {
				this.loading = false;
				this.loadingClients = false;
				this.query = '';
				this.clientsLoaded = true;
				this.total = this.searchLoaded ? this.totalClients : this.searchTotal;
			}
		},
		$route() {
			this.limit = this.$route.query.limit ? this.$route.query.limit : 10;
			this.offset = this.$route.query.offset ? this.$route.query.offset : 0;
			this.fetchAllClients([this.limit, this.offset]);
		},
		query() {
			this.queryError = '';
		}
	},
	computed: {
		...mapGetters({
			clients: 'getClients',
			status: 'getStatus',
			totalClients: 'getTotalClients'
		})
	},
	methods: {
		...mapActions(['fetchAllClients'])
	}
};
</script>

<style lang="scss" scoped>
.contacts--list__item {
	display: grid;
	grid-template-columns: 35px 2fr 100px 100px 120px 2fr 150px;
}
</style>
